export default __webpack_public_path__ + "static/leto-ea9a6a2c05c5fc885407627383074eb6.png";